import React from 'react';
import { AlertCircle, RotateCcw } from 'lucide-react';

interface PageErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function PageError({
  title = 'Ocorreu um erro',
  message = 'Não foi possível carregar as informações neste momento.',
  onRetry,
}: PageErrorProps) {
  return (
    <div className="w-full min-h-[300px] flex flex-col items-center justify-center text-center p-8 border border-rose-100/50 bg-rose-50/20 rounded-[24px]">
      <div className="w-12 h-12 rounded-2xl bg-rose-50 flex items-center justify-center text-rose-500 mb-4 shadow-2xs">
        <AlertCircle size={24} />
      </div>
      <h3 className="text-base font-bold text-slate-900 tracking-tight">{title}</h3>
      <p className="text-sm text-slate-500 font-medium max-w-sm mt-1 mb-5 leading-relaxed">{message}</p>
      
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-900 text-white text-xs font-bold hover:bg-slate-800 transition-all cursor-pointer active:scale-95 shadow-2xs"
        >
          <RotateCcw size={12} strokeWidth={2.5} />
          <span>Tentar Novamente</span>
        </button>
      )}
    </div>
  );
}

export default PageError;
